class HeaderMegaMenu {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.brandItems = wrapper.querySelectorAll('.mega-menu__brand-item');
    this.brandContents = wrapper.querySelectorAll('.mega-menu__brand-content');
    this.triggerElement = wrapper.previousElementSibling?.matches('[data-mega-menu-trigger]')
      ? wrapper.previousElementSibling
      : null;
    this.headerContainer = wrapper.closest('.header') || wrapper.parentElement;
    this.closeTimeout = null;

    HeaderMegaMenu.instances.push(this);

    this.init();
  }

  init() {
    this.bindBrandEvents();
    this.bindHoverEvents();
    this.bindOutsideClick();
  }

  bindBrandEvents() {
    this.brandItems.forEach(item => {
      item.addEventListener('click', (e) => this.onBrandItemClick(e));
      item.addEventListener('mouseenter', () => this.onBrandItemHover(item));
    });
  }

  // Open/close are driven by hover on the whole `.header` row, not the
  // trigger/wrapper pair individually: `.header-mega-menu-wrapper` is a DOM
  // descendant of `.header`, so moving the mouse from the trigger link down
  // into the dropdown never fires `.header`'s mouseleave, even across the
  // visual gap between them — no timer race needed.
  bindHoverEvents() {
    if (this.triggerElement) {
      this.triggerElement.addEventListener('mouseenter', () => this.open());
    }

    this.headerContainer.addEventListener('mouseenter', () => this.cancelClose());
    this.headerContainer.addEventListener('mouseleave', () => this.scheduleClose());
  }

  bindOutsideClick() {
    document.addEventListener('click', (e) => {
      if (!this.wrapper.contains(e.target) &&
        (!this.triggerElement || !this.triggerElement.contains(e.target))) {
        this.close();
      }
    });
  }

  cancelClose() {
    clearTimeout(this.closeTimeout);
  }

  scheduleClose() {
    this.cancelClose();
    this.closeTimeout = setTimeout(() => this.close(), 200);
  }

  onBrandItemClick(e) {
    if (e.target.tagName === 'A') return;
    e.preventDefault();
    const brandSlug = e.currentTarget.dataset.brand;
    this.showBrand(brandSlug);
  }

  onBrandItemHover(item) {
    const brandSlug = item.dataset.brand;
    this.showBrand(brandSlug);
  }

  showBrand(brandSlug) {
    this.brandItems.forEach(item => {
      if (item.dataset.brand === brandSlug) {
        item.classList.add('active');
      } else {
        item.classList.remove('active');
      }
    });

    this.brandContents.forEach(content => {
      if (content.dataset.brand === brandSlug) {
        content.classList.add('active');
      } else {
        content.classList.remove('active');
      }
    });
  }

  open() {
    HeaderMegaMenu.instances = HeaderMegaMenu.instances.filter(
      (instance) => instance.wrapper && instance.wrapper.isConnected
    );
    HeaderMegaMenu.instances.forEach((instance) => {
      if (instance !== this) instance.close();
    });
    this.cancelClose();
    this.wrapper.classList.add('active');
    if (this.triggerElement) this.triggerElement.classList.add('active');
    const firstBrand = this.brandItems[0];
    if (firstBrand) {
      this.showBrand(firstBrand.dataset.brand);
    }
  }

  close() {
    this.cancelClose();
    this.wrapper.classList.remove('active');
    if (this.triggerElement) this.triggerElement.classList.remove('active');
  }
}

HeaderMegaMenu.instances = [];

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.header-mega-menu-wrapper').forEach(wrapper => {
    new HeaderMegaMenu(wrapper);
  });
});

function initMegaMenuCollectionCarousel(track) {
  let isDown = false;
  let startX = 0;
  let scrollLeft = 0;
  let dragDistance = 0;

  // Links/images are natively draggable in the browser; once dragged they
  // capture the pointer and stop delivering mousemove to us, so the custom
  // scroll-drag below never sees the movement. Disabling `draggable`
  // directly (not just CSS) is the reliable cross-browser way to opt out.
  track.querySelectorAll('a, img').forEach((el) => {
    el.draggable = false;
  });

  track.addEventListener('mousedown', (e) => {
    isDown = true;
    startX = e.pageX - track.offsetLeft;
    scrollLeft = track.scrollLeft;
    dragDistance = 0;
    track.classList.add('is-dragging');
  });

  track.addEventListener('mouseleave', () => {
    isDown = false;
    track.classList.remove('is-dragging');
  });

  track.addEventListener('mouseup', () => {
    isDown = false;
    track.classList.remove('is-dragging');
  });

  track.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - track.offsetLeft;
    const walk = x - startX;
    dragDistance = walk;
    track.scrollLeft = scrollLeft - walk;
  });

  track.addEventListener(
    'click',
    (e) => {
      if (Math.abs(dragDistance) > 5) e.preventDefault();
    },
    true
  );
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.mega-menu__collection-list').forEach((track) => {
    initMegaMenuCollectionCarousel(track);
  });
});
document.addEventListener('DOMContentLoaded', function () {
  const productMiniatures = document.querySelectorAll('.mega-menu__product-image-miniature');

  productMiniatures.forEach(miniature => {
    miniature.addEventListener('mouseenter', function () {
      const productImage = this.dataset.productImage;
      const productFlavor = this.dataset.productFlavor;
      const productHandle = this.dataset.productHandle;
      const productTitle = this.dataset.productTitle;
      const productId = this.dataset.productId;
      const selectedProduct = this.closest('.mega-menu__collection-item').querySelector('.mega-menu__collection-selected-product');
      const activeMiniature = this.closest('.mega-menu__collection-item').querySelector('.mega-menu__product-image-miniature.active');
      if (selectedProduct) {
        const imgElement = selectedProduct.querySelector('.mega-menu__collection-image');
        const containerElement = selectedProduct.querySelector('.mega-menu__collection-selected-product-container');
        for (const mini of this.closest('.mega-menu__collection-item').querySelectorAll('.mega-menu__product-image-miniature')) {
          mini.classList.remove('active');
        }
        this.classList.add('active');
        if (imgElement && productImage) {
          imgElement.src = productImage;
        }

        selectedProduct.dataset.productHandle = productHandle || '';
        selectedProduct.dataset.productTitle = productTitle || '';
        selectedProduct.dataset.productId = productId || '';
        selectedProduct.dataset.productFlavor = productFlavor || '';

        if (containerElement) {
          containerElement.innerHTML = '';
          if (productFlavor) {
            const span = document.createElement('span');
            span.className = 'mega-menu__collection-selected-product-flavor';
            span.textContent = productFlavor;
            containerElement.appendChild(span);
          }
        }
      }
    });
  });

  document.querySelectorAll('.mega-menu__collection-selected-product').forEach(selectedProduct => {
    selectedProduct.addEventListener('click', function () {
      const { productTitle, brand, productId, productFlavor, productHandle } = this.dataset;
      if (!productHandle) return;
      insiderTracking.handleMegaMenuItemVariantClick(productTitle, brand, productId, productFlavor || '', '/products/' + productHandle);
    });
  });
});
